import React, { useEffect } from 'react';
import * as azblob from '@azure/storage-blob';
import { useState } from 'react';
import { Grid, Button, Typography } from '@material-ui/core';
import MaterialTable from 'material-table';

const ProjectData = (props) => {

    const [blobs, setBlobs] = useState([]);
    const [reportStatus, setReportStatus] = useState("");
    const [blobName, setBlobName] = useState("");
    const [blobFile, setBlobFile] = useState();
    const [tableIsLoading, setTableIsLoading] = useState(true);

    const STORAGE_ACCOUNT_NAME = "projektestorage";
    //const ACCOUNT_ACCESS_KEY = "?sv=2019-10-10&ss=bfqt&srt=co&sp=rwdlacupx&se=2020-09-01T05:48:33Z&st=2020-06-30T21:48:33Z&spr=https&sig=RnLJvY7Qb7CY%2BPvqbny7KeiDw1EvHvGTwrv7GUNXqr4%3D";
    const ACCOUNT_ACCESS_KEY = process.env.REACT_APP_STORAGE_ACCOUNT_ACCESS_KEY;
    //const containerName = props.projectType.project;
    const containerName = props.projectType.project;
    const containerURL = new azblob.ContainerURL(
        `https://${STORAGE_ACCOUNT_NAME}.blob.core.windows.net/${containerName}?${ACCOUNT_ACCESS_KEY}`,
        azblob.StorageURL.newPipeline(new azblob.AnonymousCredential));

    async function downloadBlob(blobname) {
        setBlobName(blobname);
        window.open(window.open("https://projektestorage.blob.core.windows.net/".concat(containerName, "/", blobname), "_blank"));
    }

    //useEffect(() => {

    //    console.log("blobFile state:", blobFile);

    //}, [blobFile])

    useEffect(() => {
        //trigger inside table onClick method for material table
        if (blobName !== "" && blobName) {
            window.open("https://projektestorage.blob.core.windows.net/".concat(containerName, "/", blobName), "_blank");

        }
    }, [blobName])


    useEffect(() => {
        async function listFiles() {
            try {
                setReportStatus("Retrieving file list...");
                let marker = undefined;
                do {
                    const listBlobsResponse = await containerURL.listBlobFlatSegment(
                        azblob.Aborter.none, marker);
                    marker = listBlobsResponse.nextMarker;
                    const items = listBlobsResponse.segment.blobItems;
                    //console.log("items var blob: ", items);
                    setBlobs([]);
                    var typeOfEntry = "";
                    for (const blob of items) {
                        //console.log("looping blobs:", blob);
                        var entryIdPos = blob.name.lastIndexOf('-');
                        var userEntryId = blob.name.substring(entryIdPos + 1);
                        var userNamePos = blob.name.indexOf('-');
                        var userEntryName = blob.name.substring(0, userNamePos);

                        //blob names could throw off if statements, need to search a different string
                        if (blob.name.includes("bewyse")) {
                            typeOfEntry = "Bewyse van Betaling";
                        }
                        else if (blob.name.includes("teks")) {
                            typeOfEntry = "Teks";
                        }
                        else if (blob.name.includes("pdf")) {
                            typeOfEntry = "pdf";
                        }
                        else if (blob.name.includes("kunswerk")) {
                            typeOfEntry = "Kunswerk";
                        }
                        else if (blob.name.includes("video")) {
                            typeOfEntry = "Video";
                        }
                        else {
                            typeOfEntry = "Video";
                        }


                        setBlobs(entries => [...entries,
                        {
                            "id": userEntryId,
                            "username": userEntryName,
                            "entryType": typeOfEntry,
                            "fullName": blob.name
                        }
                        ])

                        //setBlobs(entries => [...entries, blob.name]);
                    }
                } while (marker);
                if (blobs.length > 0) {
                    setReportStatus("Done.");
                } else {
                    setReportStatus("The container does not contain any files.");
                }
                setTableIsLoading(false);

            } catch (error) {
                //setReportStatus(error.message);
                console.log("ERROR!!:", error);
            }

        }
        console.log("ProjectData props:", props);
        listFiles();
    }, [])

    //useEffect(() => {
    //    //console.log("blob changed: ", blobs);
    //    setBlobName(blobs[0]);
    //}, [blobs])


    return (
        <Grid>
            <Grid container justify="center">
                <Grid item lg={12}>
                    <Typography variant="h3">{props.projectType.project} Data</Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={12}>
                    <Button onClick={() => props.history.goBack()} variant="contained" color="primary">Gaan Terug</Button>
                </Grid>

            </Grid>
            <Grid container>
                <br></br>
            </Grid>
            <Grid container>
                <MaterialTable
                    columns={[
                        { title: 'Entry Id', field: 'id' },
                        { title: 'Username', field: 'username' },
                        { title: 'Type Of File', field: 'entryType' },
                        { title: 'Full BLOB Name', field: 'fullName' },
                        {
                            title: 'Download BLOB Here', render: rowData => <Button variant="outlined" color="primary" onClick={() => downloadBlob(rowData.fullName)}>{rowData.fullName}</Button>


                        }
                    ]}
                    isLoading={tableIsLoading}
                    data={blobs}
                    title={props.projectType.project}
                />
            </Grid>
        </Grid >

    )
}

export default ProjectData;


// WEBPACK FOOTER //
// ./src/components/ProjectData.js